import { useContext } from 'react'

import { context } from './context'

export const useMediaQuery = (name: string): boolean | null => useContext(context)[name] ?? null
